export default {
  centralRegistryforModuleCertificatesZEREZ: "ZEREZ - Central registry for unit and component certificates",
};
